import * as React from "react";
import * as i from "../../../../../../contracts";
import { MarketConfigType } from "../../../../../../typings";
import { EventCardProps } from "../../../EventCard";
import { renderBetButtonsRegular } from "./renderBetButtonsRegular";
import { pickLiveOrPreliveId, prepareEmptyMarket, findFirstAvailableMarket } from "../../../../../../helpers";

export const renderMarketsRegular = (cardProps: EventCardProps, buttonsHolderClass: string, componentPrefix: string) => {
    let marketsInConfig = cardProps.sport.config.markets;
    let market = prepareMarket(cardProps.markets, marketsInConfig, cardProps.event.isLive);
    let emptyMarket = prepareEmptyMarket(cardProps, marketsInConfig[0].template, 0);

    return (
        <div key={`${componentPrefix}__buttons-holder__${cardProps.event.id}`} className= {`rj-ev-list__${componentPrefix}__buttons-holder ${buttonsHolderClass}`} data-uat={`div-ev-list-${componentPrefix}-buttons-holder`}>
            {renderBetButtonsRegular(market || emptyMarket, cardProps.handlers.betButton, cardProps, componentPrefix)}
        </div>
    )
}

const prepareMarket = (markets: i.Market[], marketsConfig: MarketConfigType[], isLive: boolean): i.Market => {
    let ids = marketsConfig.map(m => pickLiveOrPreliveId(m, isLive));

    return findFirstAvailableMarket(markets, ids);
}